import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

export const FeatureCard = ({
  image,
  imageAlt,
  title,
  highlightedText,
  description,
  imagePosition = "left", // "left" or "right"
  isMobile,
}) => {
  const muiTheme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        mb: { xs: 6, md: 8 },
        gap: { xs: 3, md: 6 },
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          flex: 1,
          order: { xs: 1, md: imagePosition === "left" ? 1 : 2 },
        }}
      >
        <img
          src={image}
          alt={imageAlt}
          loading="lazy"
          style={{
            width: '100%',
            height: 'auto',
            maxWidth: '100%',
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
            objectFit: 'cover',
          }}
        />
      </Box>
      <Box
        sx={{
          flex: 1,
          order: { xs: 2, md: imagePosition === "left" ? 2 : 1 },
          textAlign: { xs: 'center', md: imagePosition === "left" ? 'left' : 'right' },
        }}
      >
        <Typography
          variant="h5"
          sx={{
            color: muiTheme.palette.grey[800],
            fontWeight: 600,
            mb: 2,
            lineHeight: 1.3,
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            hyphens: 'auto',
            maxWidth: '100%',
          }}
        >
          {title.split(highlightedText).map((part, index) => (
            <React.Fragment key={index}>
              {part}
              {index < title.split(highlightedText).length - 1 && (
                <Box
                  component="span"
                  sx={{
                    color: muiTheme.palette.primary.main,
                    fontWeight: 700,
                  }}
                >
                  {highlightedText}
                </Box>
              )}
            </React.Fragment>
          ))}
        </Typography>
        {description && (
          <Typography
            variant="body1"
            sx={{
              color: muiTheme.palette.grey[600],
              lineHeight: 1.6,
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
              hyphens: 'auto',
              maxWidth: '100%',
            }}
          >
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
